export const enum mutations {
	PRACOVNIK_SELECT_MAPPER = 'pracovnikSelectMapper',
}
